'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

const MS_SECOND = 1000;
const MS_MINUTE = MS_SECOND * 60;
const MS_HOUR = MS_MINUTE * 60;
const MS_DAY = MS_HOUR * 24;

exports.MS_DAY = MS_DAY;
exports.MS_HOUR = MS_HOUR;
exports.MS_MINUTE = MS_MINUTE;
exports.MS_SECOND = MS_SECOND;
//# sourceMappingURL=constants.js.map
